import React from 'react';

const IconRelatorios = () => {

    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            x="0px" 
            y="0px"
            width="20" 
            height="20"
            viewBox="0 0 172 172"
            style={{fill:'#000000'}}
        >
            <g 
                fill="none" 
                fill-rule="nonzero" 
                stroke="none" 
                stroke-width="1" 
                stroke-linecap="butt" 
                stroke-linejoin="miter" 
                stroke-miterlimit="10" 
                stroke-dasharray="" 
                stroke-dashoffset="0" 
                font-family="none" 
                font-weight="none" 
                font-size="none" 
                text-anchor="none" 
                style={{mixBlendMode: 'normal'}}
            >
                <path d="M28.66667,14.33333c-7.83362,0 -14.33333,6.49972 -14.33333,14.33333v114.66667c0,7.83362 6.49972,14.33333 14.33333,14.33333h114.66667c7.83362,0 14.33333,-6.49972 14.33333,-14.33333v-114.66667c0,-7.83362 -6.49972,-14.33333 -14.33333,-14.33333zM28.66667,28.66667h28.66667v28.66667h-28.66667zM71.66667,28.66667h28.66667v28.66667h-28.66667zM114.66667,28.66667h28.66667v28.66667h-28.66667zM35.83333,35.83333v14.33333h14.33333v-14.33333zM78.83333,35.83333v14.33333h14.33333v-14.33333zM121.83333,35.83333v14.33333h14.33333v-14.33333zM28.66667,71.66667h28.66667v28.66667h-28.66667zM71.66667,71.66667h28.66667v28.66667h-28.66667zM114.66667,71.66667h28.66667v28.66667h-28.66667zM35.83333,78.83333v14.33333h14.33333v-14.33333zM28.66667,114.66667h28.66667v28.66667h-28.66667zM71.66667,114.66667h28.66667v28.66667h-28.66667zM114.66667,114.66667h28.66667v28.66667h-28.66667zM35.83333,121.83333v14.33333h14.33333v-14.33333z">
                </path>
            </g>
        </svg>
    )
}

export default IconRelatorios;
